
import React, { useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useMounted from '../../hooks/useMounted';


import SimpleReactValidator from 'simple-react-validator';
import { post } from '../../helpers/api_helper';
import { POST_GET_ITEM_DETAIL, POST_ADD_EDIT_ITEM } from '../../helpers/url_helper';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';

const Item = (props) => {
    const navigate = useNavigate();

    const [isLoader, setLoader] = useState(0);

    const simpleValidator = useRef(new SimpleReactValidator());
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState({ itemId: 0, itemName: '', itemDisplayIndex: '', itemDescription: '', itemImageUrl: '', image: '' });
    const [, forceUpdate] = useState();

    const { id } = useParams()

    useMounted(() => {
        async function get_detaile() {
            if (id) {
                var res_data = await post(POST_GET_ITEM_DETAIL, { 'id': id });
                if (res_data.status) {
                    setInputs(res_data.data.itemDetail);
                } else {
                    toast.error(res_data.message);
                    navigate("/");
                }
            }
            setLoader(1)
        }
        get_detaile();
    }, [])

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_ADD_EDIT_ITEM, form_inputs, {});
            if (res_data.status) {
                toast(res_data.message);
                navigate("/items");
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        if (event.target.name === 'image') {
            var file_extension = event.target.files[0].name.split('.').pop();
            var file_size = event.target.files[0].size;
            file_size = (file_size / 1024 / 1024).toFixed(1);

            var extension = ['png','jpg', 'jpeg'];
            if (!extension.includes(file_extension.toLowerCase())) {
                toast.error('Allow only file png, jpg and jpeg.');
                event.target.value = null;
                return false;
            }

            if (file_size > 1) {
                toast.error('Max File size Allowed 1Mb.');
                event.target.value = null;
                return false;
            }

            var file = event.target.files[0];
            var reader = new FileReader();
            reader.onload = function () {
                setInputs(inputs => ({ ...form_inputs, [event.target.name]: reader.result }));
            }
            reader.readAsDataURL(file);

        } else {
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
        }
    }



    if (!isLoader) {
        return (<Loader />);
    }
    return (
        <>
            <div className='row'>
                <div className="col-md-6">
                    <div className="card mb-4">
                        <h5 className="card-header">Item</h5>
                        <div className="card-body">
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Name *</label>
                                    <input name="itemName" value={form_inputs.itemName} onChange={handleInputChange} className="form-control" placeholder="Enter Name" type="text" />
                                    {simpleValidator.current.message('name', form_inputs.itemName, 'required')}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Description </label>
                                    <textarea name="itemDescription" value={form_inputs.itemDescription} onChange={handleInputChange} className="form-control" placeholder="Enter Description" rows={5} />
                                </div>
                                <div className='mb-3 row'>
                                    <div className='col-sm-8'>
                                        <label className="form-label text-capitalize">Bannder Image <small>1700px X 600px</small> </label>
                                        <input name="image" type="file" onChange={handleInputChange} className="form-control" />
                                    </div>
                                    <div className='col-sm-4'>
                                        <img src={form_inputs.itemImageUrl} style={{'maxWidth' : '200px', 'width' : '100%'}} alt='Item'/>
                                    </div>
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Display Index </label>
                                    <input name="itemDisplayIndex" value={form_inputs.itemDisplayIndex} onChange={handleInputChange} className="form-control" placeholder="Enter Display Index" type="text" />
                                    {simpleValidator.current.message('index', form_inputs.itemDisplayIndex, (form_inputs.itemDisplayIndex) ? 'numeric' : '')}
                                </div>


                                <div className='text-center'>
                                    <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2">
                                        {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Save
                                    </button>
                                    <Link to="/items" className="btn btn-danger ms-3"> Cancel</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Item;